export default __webpack_public_path__ + "static/media/success.321ce2c2.svg";